"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamScoreCardAllOfToJSON = exports.TeamScoreCardAllOfFromJSONTyped = exports.TeamScoreCardAllOfFromJSON = void 0;
const _1 = require("./");
function TeamScoreCardAllOfFromJSON(json) {
    return TeamScoreCardAllOfFromJSONTyped(json, false);
}
exports.TeamScoreCardAllOfFromJSON = TeamScoreCardAllOfFromJSON;
function TeamScoreCardAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'teamWithPlayers': _1.TeamWithPlayersFromJSON(json['teamWithPlayers']),
    };
}
exports.TeamScoreCardAllOfFromJSONTyped = TeamScoreCardAllOfFromJSONTyped;
function TeamScoreCardAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'teamWithPlayers': _1.TeamWithPlayersToJSON(value.teamWithPlayers),
    };
}
exports.TeamScoreCardAllOfToJSON = TeamScoreCardAllOfToJSON;
